// Copyright (c) 2021 WiseTime. All rights reserved.

import { combineEpics } from "redux-observable"
import batchGetTags from "./batchGetTags"
import batchGetTagCategories from "./batchGetTagCategories"
import fetchRecentTags from "./fetchRecentTags"
import fetchFavouriteTags from "./fetchFavouriteTags"
import searchTags from "./searchTags"
import updateTag from "./updateTag"
import createFavouriteTag from "./createFavouriteTag"
import deleteFavouriteTag from "./deleteFavouriteTag"
import reorderFavouriteTag from "./reorderFavouriteTag"
import loadOrderBy from "./loadOrderBy"
import loadRecentOrderBy from "./loadRecentOrderBy"
import persistOrderBy from "./persistOrderBy"
import createTagKeyword from "./createTagKeyword"
import deleteTagKeyword from "./deleteTagKeyword"
import getTag from "./getTag"
import persistRecentOrderBy from "./persistRecentOrderBy"
import persistViewMode from "./persistViewMode"
import searchTagsShallow from "./searchTagsShallow"
import loadViewMode from "./loadViewMode"
import listTagsByCategory from "./listTagsByCategory"
import getTagCategory from "./getTagCategory"
import { storagePrefix } from "../../../app/config"
import { Action } from "redux"
import { RootState } from "../../../app/store"

export const SEARCH_TAGS_ORDER_BY_KEY = storagePrefix + "search_tags_order_by"
export const RECENT_TAGS_ORDER_BY_KEY = storagePrefix + "recent_tags_order_by"
export const TAGS_VIEW_MODE = storagePrefix + "tags_view_mode"

export default combineEpics<Action, Action, RootState, unknown>(
  batchGetTags,
  batchGetTagCategories,
  searchTags,
  searchTagsShallow,
  fetchRecentTags,
  updateTag,
  fetchFavouriteTags,
  createFavouriteTag,
  deleteFavouriteTag,
  reorderFavouriteTag,
  loadOrderBy,
  loadRecentOrderBy,
  loadViewMode,
  persistOrderBy,
  persistRecentOrderBy,
  persistViewMode,
  createTagKeyword,
  deleteTagKeyword,
  getTag,
  listTagsByCategory,
  getTagCategory,
)
